/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApproveUserRequest
 */
export interface ApproveUserRequest {
    /**
     * 
     */
    user_type_id: string;
    /**
     * 
     */
    facility_id: string;
}

/**
 * Check if a given object implements the ApproveUserRequest interface.
 */
export function instanceOfApproveUserRequest(value: object): value is ApproveUserRequest {
    if (!('user_type_id' in value) || value['user_type_id'] === undefined) return false;
    if (!('facility_id' in value) || value['facility_id'] === undefined) return false;
    return true;
}

export function ApproveUserRequestFromJSON(json: any): ApproveUserRequest {
    return ApproveUserRequestFromJSONTyped(json, false);
}

export function ApproveUserRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApproveUserRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'user_type_id': json['user_type_id'],
        'facility_id': json['facility_id'],
    };
}

export function ApproveUserRequestToJSON(json: any): ApproveUserRequest {
    return ApproveUserRequestToJSONTyped(json, false);
}

export function ApproveUserRequestToJSONTyped(value?: ApproveUserRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user_type_id': value['user_type_id'],
        'facility_id': value['facility_id'],
    };
}

